module.exports = __webpack_public_path__ + "static/media/Edberghof02.613973f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Edberghof02.jpg
// module id = 362
// module chunks = 0